import _ from 'lodash'
import he from 'he'

function loadChidren (mainArr, parentId, resultArr, char = '---') {
  let filtedChildren = _.filter(mainArr, (e) => {
    return e.parent_id === parentId
  })

  if (filtedChildren.length > 0) {
    _.each(filtedChildren, (r, index) => {
      r.username = `${char} ${he.decode(r.username)}`
      resultArr.push(r)

      loadChidren(mainArr, r.id, resultArr, char + '---')
    })
  }
}

export default {
  listCommit (state, data) {
    let resultArr = []
    let arrayF0 = _.filter(data, (r) => {
      return r.parent_id === '0'
    })
    _.each(arrayF0, (r, index) => {
      resultArr.push(r)
      loadChidren(data, r.id, resultArr, '---')
    })

    state.list = resultArr

    state.listOptions = _.map(resultArr, function (e) {
      return { id: e.id, value: e.id, text: e.username, label: e.username }
    })
  }
}
